import { render, staticRenderFns } from "./CriarConta.vue?vue&type=template&id=432998ee&scoped=true"
import script from "./CriarConta.vue?vue&type=script&lang=js"
export * from "./CriarConta.vue?vue&type=script&lang=js"
import style0 from "./CriarConta.vue?vue&type=style&index=0&id=432998ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432998ee",
  null
  
)

export default component.exports